import i18n from '@/i18n';

const getTranslateResult = (key: string) => i18n.t(key) as string;

export const createDefaultLinkedinShareMessage = (disciplineName: string) => {
  const firstPart = getTranslateResult(
    'postgradMicrocertificate.linkedinModal.information.defaultText.firstPart',
  );
  const secondPart = getTranslateResult(
    'postgradMicrocertificate.linkedinModal.information.defaultText.secondPart',
  );
  return `${firstPart.toString()} ${disciplineName} ${secondPart.toString()}`;
};
